import { newBasicModalBundle } from '@components/basic-modal'
import { WarningButton } from '@components/button'

export function newDeleteDocumentModal(onActivate: () => void, documentName?: string) {
  return newBasicModalBundle({
    title: 'Delete Document',
    warningIcon: true,
    desc: `Are you sure you want to delete "${documentName || 'this document'}"? This action cannot be undone.`,
    buttons: [
      {
        text: 'Delete',
        onActivate,
        componentType: WarningButton,
      },
    ],
  })
}
